export const validation  = {
  blockTitleMaxChar: 100,
  blockParagraphMaxChar: 300,
  blocks: {
    min: 2,
    max: 12
  }
}
